import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { toast } from 'sonner';
import { courierKeys, mapCourierError, softDeleteCourier, useTranslation } from '@dukanti/shared';
import type { TranslationKey } from '@dukanti/shared';
import { supabase } from '@/lib/supabase';

export function useSoftDeleteCourier(storeId: string): UseMutationResult<void, unknown, string> {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation<void, unknown, string>({
    mutationFn: (courierId) => softDeleteCourier(supabase, storeId, courierId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: courierKeys.list(storeId) });
      toast.success(t('admin.couriers.toasts.deleted' as TranslationKey));
    },
    onError: (err) => {
      toast.error(t(mapCourierError(err) as TranslationKey));
    },
  });
}
